import type {
  TranslateCostFormatOptions,
  TranslateCostValue,
} from "./translate-cost.type";

import { useGetProfileLocale } from "@/entities/current-user";
import { useReferentialDefaultCurrency } from "@/entities/referential/referential-currencies";

import { getCostSymbol, translateCost } from "./translate-cost.helper";

export const useTranslateCost = () => {
  const locale = useGetProfileLocale();
  const currency = useReferentialDefaultCurrency();

  const _translateCost = (
    value: TranslateCostValue,
    formatOptions?: TranslateCostFormatOptions
  ) => {
    return translateCost(value, { locale, currency, ...formatOptions });
  };

  const _getCostSymbol = () => {
    return getCostSymbol(locale, currency);
  };

  return {
    translateCost: _translateCost,
    getCostSymbol: _getCostSymbol,
  };
};
